import React from 'react';

const CARD: React.CSSProperties = {
  background: '#FFFFFF',
  border: '1px solid #E7EAF0',
  borderRadius: 10,
  padding: '16px 18px',
  marginBottom: 14,
};

const HEAD: React.CSSProperties = {
  fontSize: 14, fontWeight: 800, color: '#66748B',
  letterSpacing: 0.5, textTransform: 'uppercase', marginBottom: 14,
};

const ROW: React.CSSProperties = {
  display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 28,
};

const TOP: React.CSSProperties = { fontSize: 17, fontWeight: 800, marginBottom: 4 };
const TOP_SUB: React.CSSProperties = { color: '#66748B', fontWeight: 500, fontSize: 13, marginLeft: 4 };
const CAPTION: React.CSSProperties = { fontSize: 11, color: '#66748B', marginBottom: 10 };
const AMTS: React.CSSProperties = {
  display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 6,
};
const BIG: React.CSSProperties = { fontSize: 17, fontWeight: 800 };
const BIG_SUB: React.CSSProperties = { ...BIG, color: '#66748B', fontSize: 14, fontWeight: 600 };
const LBL: React.CSSProperties = { fontSize: 11, color: '#66748B', marginLeft: 4 };

const BAR_SPLIT: React.CSSProperties = {
  height: 8, display: 'flex', gap: 4, alignItems: 'center',
};
const BAR_SOLID: React.CSSProperties = {
  height: 8, background: '#F0F2F5', borderRadius: 4, overflow: 'hidden',
};
const SEG_SOLID: React.CSSProperties = { height: '100%', background: '#EA580C' };
const SEG_LIGHT: React.CSSProperties = { flex: 1, height: '100%', background: '#22C55E', borderRadius: 4 };
const SEG_DARK: React.CSSProperties = { flex: 1, height: '100%', background: '#15803D', borderRadius: 4 };

export default function InvoicesProgress() {
  return (
    <div style={CARD}>
      <div style={HEAD}>Invoices</div>
      <div style={ROW}>
        <div>
          <div style={TOP}>$3,937.00 <span style={TOP_SUB}>Unpaid</span></div>
          <div style={CAPTION}>Last 365 days</div>
          <div style={AMTS}>
            <span><span style={BIG}>$3,937.00</span><span style={LBL}>Overdue</span></span>
            <span><span style={BIG_SUB}>$0.00</span><span style={LBL}>Not due yet</span></span>
          </div>
          <div style={BAR_SOLID}>
            <div style={{ ...SEG_SOLID, width: '100%' }} />
          </div>
        </div>
        <div>
          <div style={TOP}>$0.00 <span style={TOP_SUB}>Paid</span></div>
          <div style={CAPTION}>Last 30 days</div>
          <div style={AMTS}>
            <span><span style={BIG}>$0.00</span><span style={LBL}>Not deposited</span></span>
            <span><span style={BIG_SUB}>$0.00</span><span style={LBL}>Deposited</span></span>
          </div>
          <div style={BAR_SPLIT}>
            <div style={SEG_LIGHT} />
            <div style={SEG_DARK} />
          </div>
        </div>
      </div>
    </div>
  );
}